var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShuilongtou(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30_664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 8.64118C13 7.76685 12.2857 7.05148 11.4286 7.05148H6.57143V6.25663H3V15H6.57143V9.3645L13 8.64118ZM3 6.28651H6.57143V3.87207L10.4 2.44929C10.4856 2.42019 10.565 2.37218 10.6336 2.30813C10.7021 2.24409 10.7584 2.16531 10.7989 2.07653C10.8395 1.98774 10.8636 1.89077 10.8697 1.7914C10.8758 1.69203 10.8638 1.59231 10.8345 1.4982C10.8052 1.4041 10.7591 1.31753 10.6991 1.24369C10.639 1.16984 10.5662 1.11023 10.485 1.06842C10.4037 1.02662 10.3157 1.00347 10.2263 1.00036C10.1368 0.997254 10.0477 1.01425 9.96429 1.05035L3 3.87207V6.28651Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 12V10L11 10.1895V12H13Z",
    fill: "#15B9FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30_664"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShuilongtou);
export default __webpack_public_path__ + "static/media/shuilongtou.ad74dbbbde04a57a7721e2bcbfa50a68.svg";
export { ForwardRef as ReactComponent };